import { dispatch } from "../redux/redux-config";
import { parishSoft } from "../api/parish-soft-api";

// Embed notifications are isolated from the in-app ones: the /api/parishsoft
// endpoints authenticate with the ParishSoft token kept in localStorage.
const embedNotifications = {
    fetchList: async () => {
        const result = await parishSoft.getNotificationList();
        if (result?.success) {
            dispatch("EMBED_NOTIFICATIONS_LOADED", result.notifications || []);
            dispatch("EMBED_NOTIFICATIONS_UNREAD_COUNT", result.unreadCount || 0);
        }
        return result;
    },

    pollUnreadCount: async () => {
        const result = await parishSoft.getNotificationUnreadCount();
        if (result?.success) {
            dispatch("EMBED_NOTIFICATIONS_UNREAD_COUNT", result.unreadCount || 0);
        }
        return result;
    },

    markRead: async (id) => {
        const result = await parishSoft.markNotificationAsRead(id);
        if (result?.success) dispatch("EMBED_NOTIFICATIONS_MARK_READ", id);
        return result;
    },

    markAllRead: async () => {
        const result = await parishSoft.markAllNotificationsAsRead();
        if (result?.success) dispatch("EMBED_NOTIFICATIONS_MARK_ALL_READ");
        return result;
    },
};

export default embedNotifications;

export function embedNotificationsReducer(
    state = { items: [], unreadCount: 0 },
    action
) {
    switch (action.type) {
        case "EMBED_NOTIFICATIONS_LOADED":
            return { ...state, items: action.payload };
        case "EMBED_NOTIFICATIONS_UNREAD_COUNT":
            return { ...state, unreadCount: action.payload };
        case "EMBED_NOTIFICATIONS_MARK_READ":
            return {
                ...state,
                items: state.items.map((n) =>
                    n.id === action.payload ? { ...n, isRead: true } : n
                ),
                unreadCount: Math.max(0, state.unreadCount - 1),
            };
        case "EMBED_NOTIFICATIONS_MARK_ALL_READ":
            return {
                ...state,
                items: state.items.map((n) => ({ ...n, isRead: true })),
                unreadCount: 0,
            };
        default:
            return state;
    }
}
